import { coverageColor, coverageOf, modelLabel, supportedModels } from '@/domain/bikeModels';
import type { BikeModel } from '@/domain/geo';

/* One tag per station rather than one chip per model: the map paints a single colour per
   station, and two chips in two colours next to one dot would be a second visual language
   for the same fact. Colour comes from coverageColor so the tag and the dot cannot drift
   apart.

   The colour rides the dot and the border, never the words. The three coverage colours
   read between 2.5:1 and 3.5:1 against white, all of them under the 4.5:1 that 11px text
   needs, and the yellow is on the tag most leads see. Black also puts the emphasis where
   it belongs: the models are the answer, the caption beside them is not. */
export const CoverageTag = ({ models }: { models: readonly BikeModel[] }) => {
  const color = coverageColor(coverageOf(models));

  return (
    <span
      className="inline-flex w-fit items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold leading-4 text-black"
      style={{ borderColor: color }}
    >
      <span
        className="h-1.5 w-1.5 shrink-0 rounded-full"
        style={{ backgroundColor: color }}
        aria-hidden="true"
      />
      {supportedModels(models).map(modelLabel).join(' · ')}
    </span>
  );
};
